"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const ZoomIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 20 20" }),
    react_1.default.createElement("circle", { cx: "8", cy: "8", r: "7", stroke: "#8A939D", strokeWidth: "2", fillOpacity: "0" }),
    react_1.default.createElement("line", { x1: "13.4142", y1: "14", x2: "16", y2: "16.5858", stroke: "#8A939D", strokeWidth: "2", strokeLinecap: "round" }),
    react_1.default.createElement("rect", { x: "7.5", y: "5.5", width: "1", height: "5", fill: "#1C110A", stroke: "#8A939D" }),
    react_1.default.createElement("rect", { x: "10.5", y: "7.5", width: "1", height: "5", transform: "rotate(90 10.5 7.5)", fill: "#1C110A", stroke: "#8A939D" })));
exports.ZoomIcon = ZoomIcon;
exports.default = exports.ZoomIcon;
